// app/app.config.ts
import {
  ApplicationConfig,
  ErrorHandler,
  APP_INITIALIZER,
  importProvidersFrom
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app-routing.module';
import { provideTranslations } from './utils/i18n/translate.provider';
import { providePrimeNG } from 'primeng/config';
import { DatePipe } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService
} from '@ngx-translate/core';
import { Ability, PureAbility } from '@casl/ability';

import * as Sentry from '@sentry/angular';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DialogService } from 'primeng/dynamicdialog';
import { AuthService } from './services/auth/auth.service';
import { firstValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import FastRocketPreset from 'src/assets/presets/fast-rocket-preset';

// eslint-disable-next-line require-jsdoc
function initAuthFactory(auth: AuthService) {
  return () => firstValueFrom(auth.init());
}
// eslint-disable-next-line require-jsdoc
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    LoadingInterceptor,
    provideRouter(routes),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: FastRocketPreset,
        options: {
          darkModeSelector: '.app-dark'
        }
      }
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      })
    ),
    provideRouter(routes),
    provideTranslations(),
    CookieService,
    AuthService,
    ConfirmationService,
    MessageService,
    TranslateService,
    DialogService,
    DatePipe,
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuthFactory,
      deps: [AuthService],
      multi: true
    }
  ]
};
